export default __webpack_public_path__ + "static/mg-ceeb4b753488d07ed1e0c5e076fe9525.svg";